"use client";

;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import { createContext } from "react";
import type { CatalogPageResult } from "@/features/onboarding-tours/orchestrator/get-catalog-page";
import type {
	StartTourRequest,
	TourOrchestratorAction,
} from "@/features/onboarding-tours/orchestrator/tour-orchestrator";
import type { TourId } from "@/features/onboarding-tours/types/tour-definition";

export interface OnboardingToursContextValue {
	activeTourId: TourId | null;
	catalogQuery: string;
	setCatalogQuery: (query: string) => void;
	catalogPage: number;
	setCatalogPage: (page: number) => void;
	catalogPageData: CatalogPageResult;
	catalogOpen: boolean;
	setCatalogOpen: (open: boolean) => void;
	startTour: (request: StartTourRequest) => void;
	isTourActive: boolean;
	abandonTour: () => void;
	notifyTourHostDismissed: ({
		overlayGroup,
		reason,
	}: {
		overlayGroup: string;
		reason?: "complete" | "skip";
	}) => void;
}

export const OnboardingToursContext =
	createContext<OnboardingToursContextValue | null>(null);

export type PendingTourLaunch = TourOrchestratorAction | null;
